// Rewritten and downgraded in Angular 8

// /**
// @ngdoc service
// @name caseService

// @description
// Additional support for case options<br />
// camelCase<br />
// CamelCase<br />
// snake_case coming soon...<br />
// SNAKE_CASE coming soon...
// */
// angular.module('app').service('caseService', function() {
// 	var DEBUG = false;
// 	if(DEBUG) console.log('caseService');b
// 	/*
// 	TODO: add support for none lower case class rule: (find web ref)
// 	e.g. DonutMessage becomes donutMessage
// 	but  UIDonutMessage remains UIDonutMessage
// 	*/
//  	this.camelCaseSentance = function( sentance, lowercaseFirstLetter ){
// 		if(DEBUG){
// 			console.log('camelCaseSentance()', sentance, lowercaseFirstLetter);
// 		}
// 		var camelCaseSentance = '';
// 		var wordArr = sentance.split(' ');
// 		for( var i=0,l=wordArr.length; i<l; i++ ){
// 			camelCaseSentance += this.changeCaseOfFirstLetter( wordArr[i] , (i!=0) );
// 		}
// 		if(DEBUG){
// 			console.log('camelCaseSentance()',camelCaseSentance);
// 		}
// 		return camelCaseSentance;
//     };

//     this.changeCaseOfFirstLetter = function( word, uppercase ){
//     	if(DEBUG){
//     		console.log('changeCaseOfFirstLetter()', word, uppercase);
//     	}
//     	var firstLetter = word.substring(0,1);
//    		firstLetter = uppercase ? firstLetter.toUpperCase() : firstLetter.toLowerCase();
//     	var newWord = firstLetter + word.substring(1).toLowerCase();
//     	return newWord;
//     };
// });